import { useState, useEffect } from 'react';

import { OutlinedInput, InputAdornment, Select, MenuItem } from '@mui/material';

import useWindowSize from 'hooks/use-windowSize';

import SearchIcon from '@core/assets/icons/search-normal.svg';
import LocationIcon from 'assets/icons/location-icon-bold.svg';
import { ArrowDown2 } from 'iconsax-react';

import classes from './JobsFiltersForm.module.scss';

const JobsFiltersForm = ({  values, setValues }) => {
	const { mobileDevice } = useWindowSize();
	const [searchKeyword, setSearchKeyword] = useState(values?.search_keyword || '');
	const [locationKeyword, setLocationKeyword] = useState(values?.location || '');

	const formChangeHandler = (newValue, key) => {
		setValues((prevState) => ({ ...prevState, [key]: newValue.target.value}));
	};

	// const bouncerTimeout = mobileDevice ? 0 : 1500;

	// useEffect(() => {
	// 	const searchKeywordBouncer = setTimeout(() => {
	// 		setValues((prevState) => ({ ...prevState, search_keyword: searchKeyword }));
	// 	}, bouncerTimeout);
	// 	return () => {
	// 		clearTimeout(searchKeywordBouncer);
	// 	};
	// }, [searchKeyword]);

	// useEffect(() => {
	// 	const locationKeywordBouncer = setTimeout(() => {
	// 		setValues((prevState) => ({ ...prevState, location: locationKeyword }));
	// 	}, bouncerTimeout);
	// 	return () => {
	// 		clearTimeout(locationKeywordBouncer);
	// 	};
	// }, [locationKeyword]);

	return (
		<div className="d-flex flex-column flex-lg-row justify-content-between gap-3 px-2">
			<div className={`row gap-3 w-100 gap-md-0 ${classes['job-board-filters-texts']}`}>
				<div className="col-12 col-md-6">
					<OutlinedInput
						id="search_keyword"
						name="search_keyword"
						data-testid="search_keyword"
						defaultValue={values?.search_keyword || ''}
						// onChange={(newValue) => formChangeHandler(newValue, 'search_keyword')}
						onChange={(newValue) => setSearchKeyword(newValue.target.value)}
						onKeyDown={(e) => {
							console.log(e.key)
							if (e.key === 'Enter') {
								setValues((prevState) => ({ ...prevState, search_keyword: searchKeyword }));
							}
						}}
						className="w-100"
						placeholder="Search jobs, Keywords, companies"
						startAdornment={
							<InputAdornment position="start">
								<SearchIcon />
							</InputAdornment>
						}
					/>
				</div>
				<div className="col-12 col-md-6">
					<OutlinedInput
						id="location"
						name="location"
						data-testid="location"
						defaultValue={values?.location || ''}
						// onChange={(newValue) => formChangeHandler(newValue, 'location')}
						onChange={(newValue) => setLocationKeyword(newValue.target.value)}
						onKeyDown={(e) => {
							if (e.key === 'Enter') {
								setValues((prevState) => ({ ...prevState, location: locationKeyword }));
							}
						}}
						placeholder="Location (or Remote)"
						className="w-100"
						startAdornment={
							<InputAdornment position="start">
								<LocationIcon />
							</InputAdornment>
						}
					/>
				</div>
			</div>
			<div className={`row gap-3 w-100 gap-md-0 justify-content-end ${classes['job-board-filters-selects']}`}>
				<div className="col-12 col-md-5 d-flex align-items-center">
					<div style={{ minWidth: 115 }} className={classes['select-title']}>Employment Type:</div>

					<Select
						sx={{
							fontSize: '12px',
							maxWidth: 110,
							'& .MuiOutlinedInput-notchedOutline': {
								border: 'none',
							},
							'&:hover .MuiOutlinedInput-notchedOutline': {
								border: 'none',
							},
							'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
								border: 'none',
							},
							'& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input': {
								color: '#bb3a90',
								fontWeight: 700,
							},


						}}
						id={'employment_types'}
						name={'employment_types'}
						className="w-100"
						defaultValue={''}
						value={values.employment_type}
						onChange={(newValue) => formChangeHandler(newValue, 'employment_type')}
						displayEmpty
						renderValue={
							!values.employment_type
								? () => <span style={{ color: '#bb3a90', fontWeight: 700 }}>All</span>
								: undefined
						}
						data-testid={`select-employment_types`}>
						<MenuItem value="">
							All
						</MenuItem>
						<MenuItem value="full_time">
							Full Time
						</MenuItem>
						<MenuItem value="part_time">
							Part Time
						</MenuItem>
					</Select>
				</div>

				<div className="col-12 col-md-3 d-flex align-items-center">
					<div className={classes['select-title']}>Preview:</div>
					<Select
						sx={{
							fontSize: '12px',
							maxWidth: 110,
							'& .MuiOutlinedInput-notchedOutline': {
								border: 'none',
							},
							'&:hover .MuiOutlinedInput-notchedOutline': {
								border: 'none',
							},
							'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
								border: 'none',
							},
							'& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input': {
								color: '#bb3a90',
								fontWeight: 700,
							},

						}}
						id={'favorite'}
						name={'favorite'}
						className="w-100"
						defaultValue={''}
						value={values.favorite}
						onChange={(newValue) => formChangeHandler(newValue, 'favorite')}
						displayEmpty
						renderValue={
							!values.favorite
								? () => <span style={{ color: '#bb3a90', fontWeight: 700 }}>All</span>
								: undefined
						}
						data-testid={`select-favorite`}>
						<MenuItem value="">
							All
						</MenuItem>
						<MenuItem value={'true'} key={'favorite'}>
							Favorite
						</MenuItem>
					</Select>
				</div>
			</div>
		</div>
	);
};

export default JobsFiltersForm;
